import isArray from './isArray'

const nthChild = (position, rules) => {
  if (!isArray(rules))
    rules = [rules]

  const int = (rule, regex) => {
    let match = rule.match(regex) || [0]
    return parseInt(match[match.length - 1])
  }

  const match = (rule) => {
    const cycle  = int(rule, /(\d)?n/)
    const offset = int(rule, /\+\s+?(\d)/)
    const sets   = Math.ceil(position / cycle)
    const index  = position - ((sets - 1) * cycle)

    for (let i = 0; i < index; i++) {
      if (index == ((cycle * i) + offset))
        return true
    }

    return false
  }

  return rules.some(match)
}

export default nthChild
